
import type { Action } from './types';

export const SECURITY_LOGIN = 'SECURITY_LOGIN';
export const SECURITY_LOGIN_BY_IP = 'SECURITY_LOGIN_BY_IP';
export const SECURITY_USER_UPDATE = 'SECURITY_USER_UPDATE';
export const SECURITY_LOGOUT = 'SECURITY_LOGOUT';
export const SECURITY_SWITCH_USER_ACCOUNT = 'SECURITY_SWITCH_USER_ACCOUNT';
export const SECURITY_DOWNLOAD_USER_AVATAR = 'SECURITY_DOWNLOAD_USER_AVATAR';
export const SECURITY_MODAL_NO_AUTHENTICATED_STATE = 'SECURITY_MODAL_NO_AUTHENTICATED_STATE';

export function login(user: Object):Action {
  return {
    type: SECURITY_LOGIN,
    user: user,
  };
}

export function loginByIp(apiKey: any):Action {
  return {
    type: SECURITY_LOGIN_BY_IP,
    loginByIp: true,
    apiKey: apiKey,
  };
}

export function updateUser(user: Object):Action {
  return {
    type: SECURITY_USER_UPDATE,
    user: user,
  };
}

export function logout(apiKey):Action {

  return {
    type: SECURITY_LOGOUT,
    apiKey: apiKey,
  };
}

export function downloadAvatar(user: Object):Action {
    return {
        type: SECURITY_DOWNLOAD_USER_AVATAR,
        user: user,
    };
}
export function switchAccount(user: Object):Action {

    return {
        type: SECURITY_SWITCH_USER_ACCOUNT,
        user: user,
    };
}
export function setModalNoAuthenticatedState(state: string):Action {

    return {
        type: SECURITY_MODAL_NO_AUTHENTICATED_STATE,
        state: state,
    };
}



// WEBPACK FOOTER //
// ./src/actions/security.js